module.exports = __webpack_public_path__ + "static/media/logo-banco-brasil.76f08203.png";